import { useTranslation } from "@privacy/translations";
import Typography from "@mui/material/Typography";

export const EmptyPlaceholderText = () => {
  const { t } = useTranslation();
  return (
    <Typography
      sx={{
        fontSize: theme => theme.typography.pxToRem(14),
        color: theme => theme.palette.text.placeholder,
      }}
    >
      {t("DynamicForm.Inline.InputPlaceholder")}
    </Typography>
  );
};
